var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.reglesMetier.amount && _vm.reglesMetier.amount !== "0"
      ? _c("p", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("regles_metier.details.montant", {
                amount: _vm.reglesMetier.amount,
              })
            ),
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("regles_metier.details.nbecheances", {
            min: _vm.reglesMetier.nbInstallments.min,
            max: _vm.reglesMetier.nbInstallments.max,
          })
        ),
      },
    }),
    _vm._v(" "),
    _vm.reglesMetier.minInstallmentAmountType === "devise"
      ? _c("p", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("regles_metier.details.montant_devise", {
                montantMin: _vm.reglesMetier.minInstallmentAmountCurrency,
              })
            ),
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.reglesMetier.minInstallmentAmountType === "percent"
      ? _c("p", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("regles_metier.details.montant_percent", {
                montantMin: _vm.reglesMetier.minInstallmentAmountPercent,
              })
            ),
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.reglesMetier.interval.day === "0" &&
    _vm.reglesMetier.interval.month === "0" &&
    _vm.reglesMetier.interval.year === "0"
      ? _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("regles_metier.details.no_intervalle")) +
              "\n  "
          ),
        ])
      : _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("regles_metier.details.intervalle")) +
              "\n    "
          ),
          _c("b", [
            _vm.reglesMetier.interval.year > 0
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.reglesMetier.interval.year) +
                      " " +
                      _vm._s(_vm.$t("regles_metier.annee").toLowerCase())
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.reglesMetier.interval.month > 0
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.reglesMetier.interval.month) +
                      " " +
                      _vm._s(_vm.$t("regles_metier.mois").toLowerCase())
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.reglesMetier.interval.day > 0
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.reglesMetier.interval.day) +
                      " " +
                      _vm._s(_vm.$t("regles_metier.jour").toLowerCase())
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
    _vm._v(" "),
    (!_vm.reglesMetier.totalPeriod ||
      _vm.reglesMetier.totalPeriod.day === "0") &&
    (!_vm.reglesMetier.totalPeriod ||
      _vm.reglesMetier.totalPeriod.month === "0") &&
    (!_vm.reglesMetier.totalPeriod || _vm.reglesMetier.totalPeriod.year === "0")
      ? _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("regles_metier.details.no_delais_max")) +
              "\n  "
          ),
        ])
      : _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("regles_metier.details.delais_max")) +
              "\n    "
          ),
          _c("b", [
            _vm.reglesMetier.totalPeriod.year > 0
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.reglesMetier.totalPeriod.year) +
                      " " +
                      _vm._s(_vm.$t("regles_metier.annee").toLowerCase())
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.reglesMetier.totalPeriod.month > 0
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.reglesMetier.totalPeriod.month) +
                      " " +
                      _vm._s(_vm.$t("regles_metier.mois").toLowerCase())
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.reglesMetier.totalPeriod.day > 0
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.reglesMetier.totalPeriod.day) +
                      " " +
                      _vm._s(_vm.$t("regles_metier.jour").toLowerCase())
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }